<template>
  <div>
    <div id="modalTarget" class="control-section; position:relative" style="height: 350px">
      <ejs-dialog
        ref="AddEditFormsCategoryDocumentRef"
        isModal="true"
        closeOnEscape="false"
        :buttons="buttons"
        :animationSettings="animationSettings"
        :content="contentTemplate"
        :visible="visible"
        :target="target"
        :width="width"
        :position="modalPosition"
        :showCloseIcon="true"
        :header="header"
        cssClass="stage-modal-position"
      ></ejs-dialog>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { boolean } from "yargs";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";

import formsCategoryDocumentModalContent from "./forms-category-document-modal-content.vue";
import formsCategoryDocumentModalHeader from "./forms-category-document-modal-header.vue";
import { ADD_FORMS_CATEGORY_DOCUMENT } from "../store";

Vue.use(DialogPlugin);

export default {
  name: "FormsCategoryDocumentModal",
  props: {
    visible: boolean,
    data: Object,
  },
  data() {
    return {
      target: "#app",
      width: "40%",
      modalPosition: { X: "center", Y: "top" },
      animationSettings: { effect: "None" },
      header() {
        return {
          template: formsCategoryDocumentModalHeader,
        };
      },
      contentTemplate() {
        return {
          template: formsCategoryDocumentModalContent,
        };
      },
      buttons: [{ click: this.handleSaveClick, buttonModel: { content: "Save", isPrimary: true } }],
    };
  },
  mounted() {},
  methods: {
    handleSaveClick() {
      const modalContent = this.$refs.AddEditFormsCategoryDocumentRef.$children[1];
      const fileData = modalContent.validateFileUploader();

      if (fileData) {
        this.$refs.AddEditFormsCategoryDocumentRef.hide();
        this.addDocument(fileData);
      }
    },
    notify(type, message) {
      this.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === "Error" ? "e-toast-danger" : "e-toast-success",
        timeOut: 5000,
      });
      if (this.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$refs.notifierRef.show();
      }
    },
    async addDocument(document) {
      const documentType = this.$route.params.category;
      const documentName = document.fileName;
      const documentContent = document.file;

      if (document.documentId) {
        await this.$store
          .dispatch(ADD_FORMS_CATEGORY_DOCUMENT, {
            document: {
              documentType,
              documentName,
              documentContent,
              orderId: document.orderId,
              documentId: document.documentId,
            },
            category: this.$route.params.category,
          })
          .catch((error) => {
            this.notify("Error", error.response.data.message);
          });
      } else {
        await this.$store
          .dispatch(ADD_FORMS_CATEGORY_DOCUMENT, {
            document: {
              documentType,
              documentName,
              documentContent,
              orderId: document.orderId,
            },
            category: this.$route.params.category,
          })
          .catch((error) => {
            this.notify("Error", error.response.data.message);
          });
      }
    },
  },
};
</script>
<style>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";

.wrap {
  margin: 0 auto;
  width: 240px;
}
</style>
